import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { selectConfig } from '../store/wishlist/wishlistSlice';

interface LoaderProps {
  classes?: string;
}

const LoaderLC = ({ classes }: LoaderProps): JSX.Element => {
  return (
    <div className={`sk-circle ${classes}`}>
      <div className="sk-circle1 sk-child"></div>
      <div className="sk-circle2 sk-child"></div>
      <div className="sk-circle3 sk-child"></div>
      <div className="sk-circle4 sk-child"></div>
      <div className="sk-circle5 sk-child"></div>
      <div className="sk-circle6 sk-child"></div>
      <div className="sk-circle7 sk-child"></div>
      <div className="sk-circle8 sk-child"></div>
      <div className="sk-circle9 sk-child"></div>
      <div className="sk-circle10 sk-child"></div>
      <div className="sk-circle11 sk-child"></div>
      <div className="sk-circle12 sk-child"></div>
    </div>
  );
};

const LoaderTO = ({ classes }: LoaderProps): ReactElement => {
  return <div className={`sk-circle ${classes}`}></div>;
};

export default function Loader({ classes }: LoaderProps) {
  const config = useSelector(selectConfig);
  return config?.brand === 'TO' ? <LoaderTO classes={classes} /> : <LoaderLC classes={classes} />;
}
